/**
 * Credit card details. Any new ping specific credit card fields will go in here.
 */
export interface ICreditCardFundSourceDetails {
    /**
     * CardholderName
     */
    readonly cardholderName: string;
    /**
     * CardNumber
     */
    readonly cardNumber: string;
    /**
     * ExpiryMonth
     */
    readonly expiryMonth: number;
    /**
     * ExpiryYear
     */
    readonly expiryYear: number;
    /**
     * IsReusable
     */
    readonly isReusable?: boolean;
    /**
     * Label
     */
    readonly label?: string;
    /**
     * SaveCard
     */
    readonly saveCard: boolean;
    /**
     * SecurityCode
     */
    readonly securityCode: string;
}
